import { Box, Flex, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { SharingSettingsExpiration } from './SharingSettingsExpiration';
import { SharingSettingsPassword } from './SharingSettingsPassword';

export const SharingSettings = () => {
  const { t } = useTranslation('forms');

  return (
    <Box>
      <Title
        size="lg"
        order={6}
        sx={theme => ({ marginBottom: theme.other.spacing(2) })}
      >
        {t('editView.sidebar.sharing.settings.title')}
      </Title>
      <Flex direction="column" gap="md">
        <SharingSettingsPassword />
        <SharingSettingsExpiration />
      </Flex>
    </Box>
  );
};
